import { Container } from '@/components/layout';
import { Box, styled } from '@mui/material';
import { whatWeWillDoContant } from '../../constants';

export const Wrapper = styled(Box)<{ mobile: boolean }>`
  &:not(:last-child) {
    border-right: ${({ mobile }) =>
      !mobile && '1px solid rgba(255, 255, 255, 0.3)'};
  }
  &:not(:first-child) {
    padding-left: ${({ mobile }) => !mobile && '32px'};
  }
  padding-right: 30px;
  padding-bottom: ${({ mobile }) => mobile && '20px'};
`;

export const WhatWeWillDo = ({ isMobile }) => {
  return (
    <Box sx={{ backgroundColor: '#F3B923' }} width="100%">
      <Container
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingRight: '16px',
          paddingTop: isMobile ? '20px' : '48px',
          paddingBottom: isMobile ? '40px' : '78px',
        }}
      >
        <Box
          sx={{
            width: '100%',
            fontSize: '50px',
            color: '#fff',
            textAlign: 'center',
            mb: '44px',
          }}
        >
          What We’ll Do
        </Box>
        <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
          {whatWeWillDoContant.map((item) => (
            <Wrapper mobile={isMobile} key={item.title}>
              <Box mb="20px">{item.icon}</Box>
              <Box sx={{ color: '#fff', fontSize: '19px' }}>{item.title}</Box>
            </Wrapper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
